module.exports = __webpack_public_path__ + "img/fig30.aec71857.jpg";